import React, { useCallback, useMemo } from 'react'
import { Form } from 'react-bootstrap'
import { CONSTANTS } from '../../../../utils/constants'

const AgencyItem = ({ agency, level, type, selectedItems, onSelectionChange, associatedAgencies = [] }) => {
  const isDisabled = useMemo(
    () => (type !== CONSTANTS.AGENCY_TYPES.AVAILABLE ? false : associatedAgencies.includes(agency.id)),
    [type, agency.id, associatedAgencies],
  )

  const isSelected = useMemo(() => selectedItems.includes(agency.id), [selectedItems, agency.id])

  const handleSelect = useCallback(() => {
    if (isDisabled) return
    onSelectionChange(isSelected ? selectedItems.filter((id) => id !== agency.id) : [...selectedItems, agency.id])
  }, [isDisabled, isSelected, selectedItems, agency.id, onSelectionChange])

  return (
    <div className={`agency-item agency-menu-item agency-menu-level-${level} ${isDisabled ? 'disabled-item' : ''}`}>
      <div className="d-flex justify-content-between p-3 bg-white rounded shadow-sm">
        {!isDisabled && (
          <Form.Check
            type="checkbox"
            checked={isSelected}
            onChange={handleSelect}
            label={agency.label}
            id={`agency-${type}-${agency.id}`}
            key={`agency-${type}-${agency.id}`}
          />
        )}
        {isDisabled && <span>{agency.label}</span>}
      </div>
    </div>
  )
}

export default AgencyItem
